import { gql } from '@apollo/client'

import { featuredViewFieldsFragment } from 'js/lib/fragments/FeaturedViewFields.fragment'

export const magazineArticleViewFragment = gql`
    fragment MagazineArticleView on Blog {
        guid
        title
        url
        richDescription
        backgroundColor
        canEdit
        statusPublished
        canArchiveAndDelete
        inputLanguage
        isTranslationEnabled
        subtype
        featured {
            ...FeaturedViewFields
        }
        localTitle
        localRichDescription
        localDescription
        abstract
        owner {
            __typename @include(if: false)
            guid
            username
            name
            icon
            url
        }
    }
    ${featuredViewFieldsFragment}
`
